import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';

import Header from '../../components/Header';
import LeftMenu from '../../components/LeftMenu';

function Root() {
  return (
    <>
      <Header />
      <Box sx={{ display: 'flex' }}>
        <LeftMenu />
        <Box sx={{ flexGrow: 1, pt: 12, pb: 6, px: 3, height: '100%' }}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
}

export default Root;
